import type { FaireProductEntity } from "../../entity_types/product";

export const p_4egje2mrpx: FaireProductEntity = {
  token: "p_4egje2mrpx",
  type: "product",
  name: 'KNIT SWEATER TOP WITH "CHRISTMAS TREE" ALL OVER',
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/fd891cdabcd7078bbcaaf26b3cf7be5b3c14e87c91a651aca7a8f99d59c0b1b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a09b824f9852a645432fcb522a79d4bd3f124c674d7b7442e7868ba02eb7056.jpeg",
    "https://cdn.faire.com/fastly/9713c6bde5150f6e8b3337e6361ff39b17b66622f66c39e7bd4b0eadf0b9ff8a.jpeg",
    "https://cdn.faire.com/fastly/4433daa1d1e49281c3fa5d1e7ec5b95858ab1ac542ede27be5d6a28194c4142b.jpeg",
  ],
  priceDollars: 174,
  description:
    '\n\n**SWEATER ONLY**\n\n(MATCHING SET WITH: PWP6818-2)\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"\n\n',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:09.679Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
